var _this = this;

/**
 * render 所写的form 共用 属性和方法
 * @type {{data(): *, methods: {}}}
 */
export var chartMixins = {
  data: function data() {
    return {
      option: {},
      dom: null
    };
  },
  computed: {
    getechartResize: function getechartResize() {
      return this.$store.state.echartResize;
    }
  },
  watch: {
    value: {
      handler: function handler(newVal, oldVal) {
        if (this.dom) {
          this.setOption(newVal);
        } else {
          this.init();
        }
      },
      deep: true
    },
    getechartResize: function getechartResize(newVal, oldVal) {
      if (_this.dom) {
        setTimeout(function () {
          _this.resize();
        }, 500);
      }
    }
  },
  methods: {
    resize: function resize() {
      this.dom.resize();
    },
    init: function init() {},
    setOption: function setOption(value) {}
  }
};